<template>
  <div ref="ACCIDENT_TRAVAIL_LIST" :class="isCardView ? '' : 'section'">
    <section-header v-if="!hideTitle && !isCardView"
                    ref="ACCIDENT_TRAVAIL_LIST"
                    :ressource="ressource"
                    :isExtended="extended"
                    :dialog="dialog"
                    :canAdd="canAdd"
                    :addLabel="addLabel"
                    :fiche=fiche
                    :showSearch=showSearch
                    :addDisabled=addDisabled
                    :show-toggle="showToggle"
                    @search=onSearchTextUpdated
                    @extended=setExtended
                    @closeDialog=closeSection
                    @cardView=cardView
                    @callback=addItem>
    </section-header>
    <list-header v-if="isCardView"
                 :placeholder="placeholder"
                 :showSearch=showSearch
                 :isCardView="isCardView"
                 :show-toggle="showToggle"
                 @cardView=cardView
                 @search=onSearchTextUpdated>
    </list-header>
    <div v-if="extended" >
      <v-row class="ma-0 filters-row" no-gutters>
        <v-col v-for="(item, index) in headers.filter(h => getConfig(h.value).isFilterable)" cols="auto" :key="index" class="pr-2">
          <data-table-filter :headerValue="item.value"
                             :label="item.text"
                             :columnConfig="getConfig(item.value)"
                             :currentFilters="getFilters(item.value)"
                             @apply="applyFilters">
          </data-table-filter>
        </v-col>
      </v-row>
      <div v-if="!isCardView">
        <v-data-table v-model="selected"
                      dense fixed-header
                      :headers="headers"
                      :items="items"
                      :items-per-page="-1"
                      :must-sort="true"
                      :mobile-breakpoint="100"
                      class="white"
                      :hover=true
                      no-data-text="Aucune donnée"
                      :return-object=true
                      :disable-pagination="true"
                      :hide-default-footer="true"
                      :show-select="showSelect"
                      @update:sortBy="onSortUpdate"
                      @click:row="selectItem">
          <template v-slot:[`item.type`]="{ item }">
            <div :class="getClass(item)">{{ getLabel('type', item.type, item ) }}</div>
          </template>
          <template v-slot:[`item.codeRisque`]="{ item }">
            <div :class="getClass(item)">{{ getLabel('codeRisque', item.codeRisque, item ) }}</div>
          </template>
          <template v-slot:[`item.tauxPatronal`]="{ item }">
            <div :class="getClass(item)">{{ getLabel('tauxPatronal', item.tauxPatronal, item ) }}</div>
          </template>
          <template v-slot:[`item.dateEffet`]="{ item }">
            <div :class="getClass(item)">{{ getLabel('dateEffet', item.dateEffet, item ) }}</div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-row class="m-0">
              <div v-if="hasDocument(item)" class="col-2">
                <v-icon :disabled="actionProgress" @click.stop="displayDocument(item)" size="25" :color="getDocumentColor(item)">{{mdiDocument(item)}}</v-icon>
              </div>
              <div v-if="canDelete(item)" class="col-2">
                <v-icon :disabled="actionProgress" @click.stop="deleteItem(item)" size="25" color="border">fas fa-trash-can</v-icon>
              </div>
              <div v-if="canUpdate(item)" class="col-2">
                <v-icon :disabled="actionProgress" @click.stop="updateItem(item)" size="25" color="border">fas fa-pencil</v-icon>
              </div>
              <div v-if="hasAction(item)" class="col-2">
                <v-icon :disabled="actionProgress" @click.stop="execAction(item)" size="25" :color="getActionColor(item)">{{mdiAction(item)}}</v-icon>
              </div>
            </v-row>
          </template>
          <template v-for="(item, index) in headers" v-slot:[`header.${item.value}`]>
            <div :key="index" style="display: flex; align-items: center;">
              <div><span>{{ item.text }}</span></div>
              <v-icon class="sort-icon p-1" small>fas fa-arrow-up</v-icon>
            </div>
          </template>
        </v-data-table>
        <v-row v-if="showCount" class="m-0">
          <v-col cols="11">
            <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="10" class="pagination-color"></v-pagination>
          </v-col>
          <v-col class="text-right align-content-center">
            {{ filteredCount }}/{{ totalCount }}
          </v-col>
        </v-row>
      </div>
      <div v-else class="card-list-container">
        <div v-for="(item, index) in items" :key="index" class="pb-2">
          <v-row @click="selectItemCard(item)" class="list-card">
            <v-col>
              <v-row class="ma-0">
                <div class="list-logo list-logo-initial">
                  <div>{{ getInitials(item) }}</div>
                </div>
                <div style="padding-left: 12px;">
                  <div class="card-title">
                    {{ getTitle(item.type) }}
                  </div>
                </div>
              </v-row>
              <div class="seperator"/>
              <v-row class="ma-0">
                <div class="info-box">
                  <div class="info-header">Taux patronal</div>
                  <div class="info-text">{{ item.tauxPatronal }} <span v-if="item.tauxPatronal">%</span>
                    <v-icon v-if="item.tauxPatronal" class="copy-text-icon" @click.stop="copyText(item.tauxPatronal, 0+index)">{{ copiedField === 0+index ? 'fas fa-check' : 'fas fa-copy' }}</v-icon>
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-header">Date d'effet</div>
                  <div class="info-text">{{ new Date(item.dateEffet) }}
                    <v-icon v-if="item.dateEffet" class="copy-text-icon" @click.stop="copyText(item.dateEffet, 1+index)">{{ copiedField === 1+index ? 'fas fa-check' : 'fas fa-copy' }}</v-icon>
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-header">Code risque</div>
                  <div class="info-text">{{ item.codeRisque }}
                    <v-icon v-if="item.codeRisque" class="copy-text-icon" @click.stop="copyText(item.codeRisque, 2+index)">{{ copiedField === 2+index ? 'fas fa-check' : 'fas fa-copy' }}</v-icon>
                  </div>
                </div>
              </v-row>
            </v-col>
            <v-col cols="1" class="align-content-center align-items-center">
              <v-icon class="chevron-right">
                fas fa-chevron-right
              </v-icon>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <div v-if="!hasItems && isCardView" class="empty-list-container">
      <img src="@/assets/SVG/empty-list.svg" class="empty-list-logo"/>
      <div class="empty-list-label">{{ getNewLabel() }}</div>
    </div>
    <div class="pt-3" v-if="canAdd && isCardView">
      <v-btn class="base"
             :outlined="true"
             :loading="loading"
             :block="true"
             variant="flat"
             @click="addItem">
        {{ addLabel }}
      </v-btn>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :label="button.label"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <section-container :section="section"
                       :dialogOpen="dialogOpen"
                       :extended="true"
                       :fullscreen="fullscreen"
                       @closeDialog="closeDialog"
                       @saved="saved"
                       @updated="setUpdated">
    </section-container>
  </div>
</template>

<script lang="ts">
import SectionAccidentTravailList from '@/generated/sections/SectionAccidentTravailList.vue';
import SectionAccidentTravail from '@/extend/sections/SectionAccidentTravailExtend.vue';
import Section from '@/framework/base/classes/Section';
import AccidentTravail from '@/extend/classes/AccidentTravail';
import {storeAccidentTravail, storeAdresse} from '@/generated/stores';
import Etablissement from '../classes/Etablissement';
import ListData from '@/extend/classes/ListData';
import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
import { defineComponent, type PropType } from "vue";
import Apprenti from "@/extend/classes/Apprenti.ts";
import Route from "@/extend/classes/Route.ts";
import {Fiches} from "@/generated/classes/AppSchema.ts";
import AccidentTravailType from "@/extend/controls/accidentTravail/AccidentTravailType.ts";
import Item from "@/framework/base/classes/Item.ts";
import type Adresse from "@/generated/classes/Adresse.ts";

export default defineComponent({
  components: {},
  extends: SectionAccidentTravailList,
  props: {
    etablissement: {
      type: Object as PropType<Etablissement>,
      required: true
    }
  },
  data() {
    return {
      selectedAccidentTravail: new AccidentTravail(),
      isCardView: true
    };
  },
  computed: {
    section(): Section {
      const section = new Section();
      section.component = SectionAccidentTravail;
      section.type = 'accidentTravail';
      section.data = this.selectedAccidentTravail;
      section.ressource = this.ressource;
      return section;
    },
    showSearch() : boolean {
      return false;
    },
    canAdd() : boolean {
      return true;
    },
    showCount(): boolean {
      return false;
    },
    addresse(): Adresse {
      return storeAdresse.getAdresse(this.etablissement.adresseId);
    },
  },
  methods: {
    defaultFilter(): void {
      let source = 1;
      if (
          this.addresse.codePostal.startsWith('57') ||
          this.addresse.codePostal.startsWith('67') ||
          this.addresse.codePostal.startsWith('68')
      ) {
        source = 3;
      }
      {
        const columnFilter = new ColumnFilter();
        columnFilter.name = "etablissementId";
        columnFilter.staticFilter = true;
        const choix = new ListChoix();
        choix.value = this.etablissement.id
        columnFilter.filters.push(choix);
        const choixAutre = new ListChoix();
        choixAutre.value = 0;
        columnFilter.filters.push(choixAutre);
        this.activeFilters.push(columnFilter);
      }
      {
        const columnFilter = new ColumnFilter();
        columnFilter.name = "brancheId";
        columnFilter.staticFilter = true;
        const choix = new ListChoix();
        choix.value = this.etablissement.brancheId
        columnFilter.filters.push(choix);
        const choixAutre = new ListChoix();
        choixAutre.value = 0;
        columnFilter.filters.push(choixAutre);
        this.activeFilters.push(columnFilter);
      }
      {
        const columnFilter = new ColumnFilter();
        columnFilter.name = "source";
        columnFilter.staticFilter = true;
        const choix = new ListChoix();
        choix.value = source;
        columnFilter.filters.push(choix);
        {
          const choixAutre = new ListChoix();
          choixAutre.value = 5;
          columnFilter.filters.push(choixAutre);
        }
        {
          const choixAutre = new ListChoix();
          choixAutre.value = 6;
          columnFilter.filters.push(choixAutre);
        }
        this.activeFilters.push(columnFilter);
      }
      {
        const columnFilter = new ColumnFilter();
        columnFilter.name = "dateEffet";
        columnFilter.staticFilter = true;
        columnFilter.sortDescending = true;
        this.activeFilters.push(columnFilter);
      }
    },
    loadTable(): void {
      AccidentTravail.list(this.filter).then((res) => {
        this.listData = new ListData();
        this.listData = res;
        this.pageNumber = res.currentPage;
        this.loading = false;
        if (this.isAbstract && res.reccords.length == 0) {
          this.addItem();
        }
      });
    },
    addItem(): void {
      this.selectedAccidentTravail = storeAccidentTravail.createNewAccidentTravail();
      this.selectedAccidentTravail.etablissementId = this.etablissement.id;
      this.selectedAccidentTravail.type = 1;
      if (this.isAbstract) {
        this.$emit("openCrud", this.section);
      } else {
        this.dialogOpen = true;
      }
    },
    selectItem(event: any, row: any): void {
      const obj = row.item as AccidentTravail;
      this.selectedAccidentTravail.fromAccidentTravail(obj)
      if (this.isAbstract) {
        this.$emit("openCrud", this.section);
      } else {
        this.dialogOpen = true;
      }
    },
    selectItemCard(item: any): void {
      const obj = item as AccidentTravail;
      this.selectedAccidentTravail.fromAccidentTravail(obj)
      if (this.isAbstract) {
        this.$emit("openCrud", this.section);
      } else {
        this.dialogOpen = true;
      }
    },
    updateItem(item: any): void {
      this.selectedAccidentTravail.fromAccidentTravail(item as AccidentTravail)
      if (this.isAbstract) {
        this.$emit("openCrud", this.section);
      } else {
        this.dialogOpen = true;
      }
    },
    getInitials(value: any): string {
      let res = "";
      const items: Item[] = [
        { "key": 1, "title": "cas général" },
        { "key": 2, "title": "bureau" },
        { "key": 3, "title": "autre1" },
        { "key": 4, "title": "autre2" }
      ];
      items.forEach(item => {
        if (value.type == item.key && !res) {
          res = item.title;
        }
      })
      const initials = res.split(/[ -]+/);
      if (initials.length > 1) {
        return initials[0][0] + initials[initials.length - 1][0];
      } else {
        return initials[0][0] + initials[0][1];
      }
    },
    getTitle(value: any): string {
      let res = "";
      const items: Item[] = [
        { "key": 1, "title": "cas général" },
        { "key": 2, "title": "bureau" },
        { "key": 3, "title": "autre1" },
        { "key": 4, "title": "autre2" }
      ];
      items.forEach(item => {
        if (value == item.key && !res) {
          res = item.title;
        }
      })
      return res;
    },
    saved(value: any): void {
      this.reloadTable();
    },
  }
})

</script>
